import { cn } from "../lib/utils";

export function CrossFrameworkMapping({
  rows,
  className,
}) {
  return (
    <div className={cn("glass-card p-6", className)}>
      <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
        Cross-framework mapping
      </div>
      <h3 className="mt-2 text-2xl font-extrabold tracking-[-0.02em] text-text-primary md:text-3xl">
        Indian regulation cross-reference
      </h3>

      <div className="mt-6 overflow-x-auto">
        <table className="min-w-[900px] w-full border-separate border-spacing-0">
          <thead className="bg-background-tertiary/80 backdrop-blur-xl">
            <tr>
              {[
                "Control Area",
                "RBI",
                "SEBI",
                "IRDAI",
                "CERT-In",
              ].map((h) => (
                <th
                  key={h}
                  className="border-b border-border-subtle px-3 py-3 text-left text-xs font-semibold uppercase tracking-wide text-text-muted"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.controlArea} className="hover:bg-white/5">
                <td className="border-b border-border-subtle px-3 py-3 text-sm font-semibold text-text-primary">
                  {r.controlArea}
                </td>
                <td className="border-b border-border-subtle px-3 py-3 text-sm text-text-secondary">
                  {r.rbi}
                </td>
                <td className="border-b border-border-subtle px-3 py-3 text-sm text-text-secondary">
                  {r.sebi}
                </td>
                <td className="border-b border-border-subtle px-3 py-3 text-sm text-text-secondary">
                  {r.irdai}
                </td>
                <td className="border-b border-border-subtle px-3 py-3 text-sm text-text-secondary">
                  {r.certIn}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
